import { __decorate, __metadata } from "tslib";
import { Component } from 'angular-ts-decorators';
import { ProductContextService } from 'src/Foundation/Design/app';
import template from './faq-teasers-spot.component.html';
var FaqTeasersSpotComponent = (function () {
    function FaqTeasersSpotComponent(productContextService) {
        this.productContextService = productContextService;
    }
    FaqTeasersSpotComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.productContextService
            .subscribe()
            .then(null, null, function (group) {
            _this.group = group;
        });
    };
    FaqTeasersSpotComponent.$inject = ['productContextService'];
    FaqTeasersSpotComponent = __decorate([
        Component({
            selector: 'faqTeasersSpot',
            template: template,
        }),
        __metadata("design:paramtypes", [ProductContextService])
    ], FaqTeasersSpotComponent);
    return FaqTeasersSpotComponent;
}());
export { FaqTeasersSpotComponent };
